/**
 * Import Vue
 */
import Vue from 'vue';


/**
 * Import and use VueX
 */
import VueX from 'vuex';
Vue.use(VueX);


/**
 * Import modules
 */
import configurations from './modules/configurations'
import sliders from './modules/sliders';
import news from './modules/news';
import recruitment from './modules/recruitment';

/**
 * Export default Store
 */
export default new VueX.Store({
    modules: {
        configurations: configurations,
        sliders: sliders,
        news: news,
        recruitment: recruitment
    }
})
